import React, { useContext, useState } from 'react';

import './UserRegistrationForm.css';
import '../../styles/colors.css';
import localize from '../../i18n/localize';
import callBackend from '../../utils/callBackend';
import LocalizedContext from '../../i18n/LocalizedContext';
import SearchFencer from '../search/SearchFencer';

const UserRegistrationForm = props => {
    const language = props.language;
    const lang = useContext(LocalizedContext);

    const [email, setEmail] = useState('');
    const [searchingMode, setSearchingMode] = useState(false);
    const [fencer, setFencer] = useState('');
    const [registrationComplete, setRegistrationComplete] = useState(false);

    const changeEmailHandler = event => {
        setEmail(event.target.value);
    };

    const setFencerHandler = fencer => {
        setFencer(fencer);
        if(fencer) setSearchingMode(false);
    };

    const registrationHandler = () => {
        callBackend('sendLoginEmail', {fencer, emailAddress: email, language});
        setRegistrationComplete(true);
    };

    const search = searchingMode ? 
        <SearchFencer setFencerHandler={setFencerHandler} /> : 
        <div>
            {fencer}
            <span className='UserRegistrationForm-text' onClick={() => setSearchingMode(true)}>{localize(lang, 'fencerToRegister')}</span>
        </div>;

    const confirmButton = (() => {
        if( fencer && email )
            return (
                <tr>
                    <td className="UserRegistrationForm-button" colSpan="2">
                        <center>
                            <span className='UserRegistrationForm-text' onClick={() => registrationHandler()}>{localize(lang, 'registerAction')}</span>
                        </center>
                    </td>
                </tr>);
        else return '';
    })();

    if(registrationComplete)
        return (
            <div>
                <div className='UserRegistrationForm-header'>
                    {localize(lang, 'userRegistration')}
                </div>
                <div className='UserRegistrationForm-info'>
                {localize(lang, 'registerEmail')}
                </div>
            </div>);

    return (
        <div>
            <div className='UserRegistrationForm-header'>
                {localize(lang, 'userRegistration')}
            </div>
            <div className='UserRegistrationForm-description'>
                <table>
                    <tbody>
                        <tr>
                            <td className='UserRegistrationForm'>{localize(lang, 'email')}:</td>
                            <td className='UserRegistrationForm'><input className='UserRegistrationForm' type='text' onChange={changeEmailHandler} value={email} /></td>
                        </tr>
                        <tr>
                            <td className='UserRegistrationForm'>{localize(lang, 'fencerName')}:</td>
                            <td className='UserRegistrationForm'>
                                {search}
                            </td>
                        </tr>
                        {confirmButton}
                    </tbody>
                </table>                
            </div>
        </div>
    );
};

export default UserRegistrationForm;